import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GtwSnackbarService } from '../../shared/_services/gtw-snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class Fir8858GaapDrilldownService {
  constructor(private gtwSnackbarService: GtwSnackbarService) {}

  ELIMINATION_SAVE(data: any[]): Observable<any> {
    const totalAmt = (data || []).reduce((sum: number, row: any) => {
      const amt = row?.AMOUNT;
      return sum + (amt !== null && amt !== undefined ? Number(amt) : 0);
    }, 0);
    if (totalAmt !== 0) {
      this.gtwSnackbarService.openSnackBar('*Elimination must net to 0.', 'gtw-snackbar--red');
      return of({ callSuccess: '0', errorMessage: '*Elimination must net to 0.' });
    }
    // AngularJS service currently validates only; save logic is commented there.
    return of({ callSuccess: '1' });
  }
}
